import { createContext, useContext, useEffect, type ReactNode } from 'react';
import { useGetBrand, type Brand } from '../hooks/brand/useBrand';
import { currentBrand, applyBrandTheme } from '../config/brand';

interface BrandContextValue {
  brand: Brand | undefined;
  logoUrl: string;
  logoIconUrl: string;
  isFetching: boolean;
}

const BrandContext = createContext<BrandContextValue | null>(null);

export function BrandProvider({ children }: { children: ReactNode }) {
  const { brand, isFetching } = useGetBrand();

  // Re-apply theme if brand config changes (e.g. hot-swap in dev)
  useEffect(() => {
    applyBrandTheme();
  }, []);

  return (
    <BrandContext.Provider
      value={{
        brand,
        logoUrl: currentBrand.logoUrl,
        logoIconUrl: currentBrand.logoIconUrl ?? currentBrand.logoUrl,
        isFetching,
      }}
    >
      {children}
    </BrandContext.Provider>
  );
}

export function useBrandContext() {
  const ctx = useContext(BrandContext);
  if (!ctx) throw new Error('useBrandContext must be used within BrandProvider');
  return ctx;
}
